import { Box, Typography } from '@mui/material';
import LogoEdilSystem from '../../assets/full-color-logo.svg';

type Props = {
  backgroundColor?: string;
};

const Footer: React.FC<Props> = ({ backgroundColor = 'background.paper' }) => {
  const handleClick = () => {
    window.open('https://www.edilsystem.com.br', '_blank');
  };

  return (
    <Box
      component="footer"
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap={0.1}
      mt={2}
      sx={{
        backgroundColor,
        borderColor: 'divider',
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <Typography variant="body2" color="textSecondary">
        Copyright ©
      </Typography>
      <Box component="img" src={LogoEdilSystem} alt="Logo Edil System" width={120} />
      <Typography variant="body2" color="textSecondary">
        {new Date().getFullYear()}.
      </Typography>
    </Box>
  );
};

export default Footer;
